/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConveyorConfigurationEnum } from './conveyorConfigurationEnum';
import { RobotTypeEnum } from './robotTypeEnum';


export interface ProgramSettings { 
    robotType?: RobotTypeEnum;
    /**
     * In what angle should robot approach pallet or previous layer when placing a box on pallet
     */
    approachAngle?: number;
    /**
     * Distance from pallet frame for the approach point when placing a box on pallet
     */
    approachDistance?: number;
    conveyorConfiguration?: ConveyorConfigurationEnum;
    /**
     * How is the box oriented on the conveyor. Is the long side or the short side leading in the forward direction of the conveyor.
     */
    boxOrientationOnConveyor?: ProgramSettings.BoxOrientationOnConveyorEnum;
    /**
     * Where is the label placed on the box. Front is the leading side in the direction of the conveyor. Right is to the right hand side in the direction of the conveyor etc.
     */
    labelPosition?: ProgramSettings.LabelPositionEnum;
    /**
     * Additional height of electrical pedestal or pedestal spacer (mm). Null or zero means that the robot does not have an extended pedestal.
     */
    additionalPedestalHeight?: number;
    /**
     * Enable / disable gripper configuration for 90 degrees picking
     */
    ninetyDegreePicking?: boolean;
}
export namespace ProgramSettings {
    export type BoxOrientationOnConveyorEnum = 'SHORT_SIDE_LEADING' | 'LONG_SIDE_LEADING';
    export const BoxOrientationOnConveyorEnum = {
        SHORT_SIDE_LEADING: 'SHORT_SIDE_LEADING' as BoxOrientationOnConveyorEnum,
        LONG_SIDE_LEADING: 'LONG_SIDE_LEADING' as BoxOrientationOnConveyorEnum
    };
    export type LabelPositionEnum = 'FRONT' | 'FRONT_RIGHT_CORNER' | 'RIGHT' | 'RIGHT_BACK_CORNER' | 'BACK' | 'BACK_LEFT_CORNER' | 'LEFT' | 'LEFT_FRONT_CORNER' | 'IGNORE';
    export const LabelPositionEnum = {
        FRONT: 'FRONT' as LabelPositionEnum,
        FRONT_RIGHT_CORNER: 'FRONT_RIGHT_CORNER' as LabelPositionEnum,
        RIGHT: 'RIGHT' as LabelPositionEnum,
        RIGHT_BACK_CORNER: 'RIGHT_BACK_CORNER' as LabelPositionEnum,
        BACK: 'BACK' as LabelPositionEnum,
        BACK_LEFT_CORNER: 'BACK_LEFT_CORNER' as LabelPositionEnum,
        LEFT: 'LEFT' as LabelPositionEnum,
        LEFT_FRONT_CORNER: 'LEFT_FRONT_CORNER' as LabelPositionEnum,
        IGNORE: 'IGNORE' as LabelPositionEnum
    };
}


